import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import KatalogDlaBani from './../block/KatalogDlaBani'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class Gotovie extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <KatalogDlaBani
          title={`Готовые окна <span>от производителя</span>`}
          rtext={`[Каталог]`}
          text={`Готовые окна - это окна без брака, зарапин и дефектов, которые по опеределенным причинам не подошли нашим заказчикам.`}
          list={data?.katalog || []}
          assets_path={assets_path}
          className={`y`}
          imageVar={2}
          show_icons={false}
          btn={`Подобрать окно`}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Gotovie.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Gotovie.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Gotovie